import React from 'react';
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import DivTable from "../../components/divTable";
import MyToggle from "../../components/myToggle";
import {toast} from "react-toastify";
import {Button} from "react-bootstrap";

class Remediations extends ScreenComponent {
    constructor(props) {
        super(props);
        this.state = {
            remediations: []
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.SAR}`);

        this.setState({
                remediations: body.sort((a, b) => a.RemediationCode > b.RemediationCode ? 1 : -1)
            },
            () => this.state.remediations.filter(f => f.RemediationEstInscrit).map(m => this.updateChecked(m, true))
        );
    }

    updateChecked(elm, checked) {
        elm.ref.setState({
            checked: checked !== null ? checked : !elm.RemediationEstInscrit
        }, () => {
            elm.hasBeenModified = true;
            elm.RemediationEstInscrit = checked !== null ? checked : !elm.RemediationEstInscrit;

            this.setState({
                remediations: this.state.remediations
            });
        });
    }

    async save() {
        const body = this.state.remediations.filter((item) => item.hasBeenModified);

        if (body.length === 0) {
            return toast.warning("Veuillez effectuer au moins un changement.");
        }

        this.state.remediations.forEach((item) => {
            item.ref.setState({disabled: true});
            delete item.ref;
            delete item.hasBeenModified;
        });

        const data = Object.assign({}, {
            Items: body
        });

        await Post(`/v1/extranet/student/${screens.SAR}`, data, "Sauvegarde en cours...", {render: "Sauvegarde réussie !"}, {render: "Erreur lors de la sauvegarde"});

        this.setState({ remediations: [] }, () =>  this.componentDidMount());
    }

    render() {
        return (
            <>
                <section>
                    {this.state.remediations !== 0 && <DivTable
                        columns={{
                            "Sélection": (item) => <MyToggle ref={(r) => item.ref = r}
                                                             onChange={this.updateChecked.bind(this, item, null)}
                            />,
                            "Code": "RemediationCode",
                            "Libelle": (item) => item.RemediationLibelleLong.split('(')[0].split('[')[0],
                            "Quadri": "RemediationQuadrimestre",
                            "Public cible": "RemediationPublicCible",
                            "Date(s) d'affectation": (item) => item.RemediationIntervalles.split(", ").map(m => <><span>{m}</span><br/></>)
                        }}
                        array={this.state.remediations}
                    />}
                    <br/>
                    <br/>
                    <Button type="submit"
                            onClick={this.save.bind(this)}
                            variant="success"
                            size={"lg"}
                            className={"mr-3"}
                            block>
                        Sauvegarder
                    </Button>
                </section>
            </>
        );
    }
}

export default withRouter(Remediations);